import { More } from "@/shared/actions/more";
import { useBpmRoleRemove } from "@/modules/bpm/features/remove-bpm-role";

export type BpmRolesListItemOptionsProps = {
  bpmRoleId: string;
};

export function BpmRolesListItemOptions({
  bpmRoleId,
}: BpmRolesListItemOptionsProps) {
  const { remove } = useBpmRoleRemove();

  return (
    <More
      menu={{
        items: [
          {
            key: "delete",
            label: <More.Delete onClick={() => remove(bpmRoleId)} />,
          },
        ],
      }}
    />
  );
}
